// Textos legales de PreventiApp — Chile.
// Fuente responsable: Inside Ltda.
// Última actualización: 2026-02

export const EMPRESA = {
  razonSocial: 'Inside Ltda.',
  rut: '78.476.790-6',
  direccion: 'Av. Isabel La Católica 4394, of. 517, Las Condes, Santiago, Chile',
  emailGeneral: 'contacto@preventiapp.com',
  emailPrivacidad: 'privacidad@preventiapp.com',
  telefono: '+56 2 2973 6035',
  whatsapp: '+56 9 9609 9788',
  sitio: 'https://preventiapp.com',
  plataforma: 'https://app.preventiapp.com',
};

export const LEGAL_LAST_UPDATE = '2026-02-01';
